export enum Experiment {
  LoyaltyThumbnails = 'loyaltyThumbnails',
}
